import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './ErrorPages.scss';

const InternalServerError = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-container">
      <h1 className="not-found-title">500</h1>
      <p className="not-found-message">{t('internal_server_error_message')}.</p>
      <button className="not-found-button" onClick={goHome}>{t('go_home')}</button>
    </div>
  );
};

export default InternalServerError;
